import React, { useEffect } from 'react';
import './campos-componente-carrossel.component.scss';
import { Button, FormControl, FormControlLabel, FormLabel, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useInput } from '../../hooks/useInput.hook';
import { ItensMenuModel } from '../../models/menu.model';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import SessaoModel from '../../models/sessao.model';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { CONSTANTS } from '../../constants/constants';
import AttachmentModalComponent from '../attachment-modal/attachment-modal.component';
import { ComponentsModel } from '../../models/layout.model';
import IDsMenuSelectComponent from '../ids-menu-select/ids-menu-select.component';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import OpenWithIcon from '@mui/icons-material/OpenWith';
import Accordion from '@mui/material/Accordion';
import AddIcon from '@mui/icons-material/Add';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ItensCarrossel } from '../../models/carrossel.model';
import CamposItemCarrosselComponent from '../campos-item-carrossel/campos-item-carrossel.component';


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type CamposComponenteCarrosselComponentProps = {
  setVal: (val: ComponentsModel) => void;
  removeItem: (id?: string) => void;
  componente?: ComponentsModel;
  menu: ItensMenuModel[];
}

function CamposComponenteCarrosselComponent(props: CamposComponenteCarrosselComponentProps) {

  const [idInput, setIdInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel.id : '');
  const [tituloInput, setTituloInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.titulo : '');
  const [descricaoInput, setDescricaoInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.descricao : '');
  const [qtdPorSlideInput, setQtdPorSlideInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.qtd_por_slide : 1);
  const [bgInput, setBgInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.bg : '');
  const [corDoTituloInput, setCorDoTituloInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.cor_do_titulo : '');
  const [corDoTextoInput, setCorDoTextoInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.cor_do_texto : '');
  const [corDeFundoLegendaInput, setCorDeFundoLegendaInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.cor_de_fundo_legenda : '');
  const [corDoTextoLegendaInput, setCorDoTextoLegendaInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.cor_do_texto_legenda : '');
  const [corDoBulletsInput, setCorDoBulletsInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.cor_do_bullets : '');
  const [corDaBordaInput, setCorDaBordaInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.cor_da_borda : '');
  const [loopInput, setLoopInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.loop : false);
  const [autoPlayInput, setAutoPlayInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.autoplay : false);
  const [fullInput, setFullInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.full : false);
  const [bordaArredondadaInput, setBordaArredondadaInput] = React.useState(props.componente?.carrossel ? props.componente.carrossel?.borda_arredondada : false);
  const [itensCarrossel, setItensCarrossel] = React.useState<any>(props.componente?.carrossel ? props.componente.carrossel?.itens : []);

  const [valueTab, setValueTab] = React.useState(0);

  // SalvarPainelService.getSalvar().subscribe(() => {
  //   handleChangeItem();
  // });

  useEffect(() => {
    handleChangeItem();
  }, [itensCarrossel]);

  const handleChangeItem = () => {
    props.setVal({
      id: props.componente?.id,
      tipo: CONSTANTS.TIPO_COMPONENTE.CARROSSEL,
      carrossel: {
        id: idInput,
        titulo: tituloInput,
        descricao: descricaoInput,
        qtd_por_slide: qtdPorSlideInput,
        bg: bgInput,
        cor_do_titulo: corDoTituloInput,
        cor_do_texto: corDoTextoInput,
        cor_de_fundo_legenda: corDeFundoLegendaInput,
        cor_do_texto_legenda: corDoTextoLegendaInput,
        cor_do_bullets: corDoBulletsInput,
        cor_da_borda: corDaBordaInput,
        loop: loopInput,
        autoplay: autoPlayInput,
        full: fullInput,
        borda_arredondada: bordaArredondadaInput,
        itens: itensCarrossel
      }
    });
  };

  // Carrossel
  const addCarrossel = () => {
    const items = [...itensCarrossel];
    const newItem: ItensCarrossel = {
      id: 'item_carrossel-' + itensCarrossel.length,
      titulo: 'Novo carrossel',
      descricao: '',
      imagem: '',
      imagem_mobile: ''
    };

    items.push(newItem);

    setItensCarrossel(items);
  };

  const handleOnDragEndCarrossel = (result: any) => {

    const items = Array.from(itensCarrossel);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setItensCarrossel(items);
  }

  const handleChageItemCarrossel = (item: ItensCarrossel) => {

    const items = [...itensCarrossel];
    const itemEncontrado: ItensCarrossel = items.find(
      a => a.id === item.id
    );
    itemEncontrado.titulo = item.titulo;
    itemEncontrado.descricao = item.descricao;
    itemEncontrado.imagem = item.imagem;
    itemEncontrado.imagem_mobile = item.imagem_mobile;

    setItensCarrossel(items);
  }

  const removerItemCarrossel = (id?: string) => {
    setItensCarrossel(
      itensCarrossel.filter(a =>
        a.id !== id
      )
    );
  }
  // Fim Carrossel

  return (
    <section className="campos-componente-carrossel">
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={valueTab}
            onChange={(event: React.SyntheticEvent, newValue: number) => setValueTab(newValue)}
            aria-label="scrollable force tabs example">
            <Tab label="Geral" {...a11yProps(0)} />
            <Tab label="Estilo" {...a11yProps(1)} />
            <Tab label="Opções" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTab} index={0}>
          <h2>Geral</h2>
          {
            (props.menu.length && props.componente) &&
            <div className="campo w100">
              <IDsMenuSelectComponent val={props.componente?.carrossel?.id} menus={props.menu} setVal={(val) => setIdInput(val)} />
            </div>
          }
          <div className="campo w100">
            <TextField value={tituloInput} onChange={(event) => setTituloInput(event.target.value)} label="Título" />
          </div>
          <div className="campo w100">
            <TextField rows={3} multiline value={descricaoInput} onChange={(event) => setDescricaoInput(event.target.value)} label="Descrição" />
          </div>
          <h2>Itens do carrossel</h2>
          <DragDropContext onDragEnd={handleOnDragEndCarrossel}>
            <Droppable droppableId="itens-menus">
              {(provided) => (
                <div className="itens-menus" {...provided.droppableProps} ref={provided.innerRef}>
                  {
                    itensCarrossel?.map((item, iMenu) => (
                      <Draggable key={item.id} draggableId={item.id} index={iMenu}>
                        {(provided) => (
                          <Accordion ref={provided.innerRef} {...provided.draggableProps} >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={item.id + '-content'}
                              id={item.id + '-header'}
                              {...provided.dragHandleProps}
                            >
                              <Typography component="span"><OpenWithIcon /> Item carrossel {item.titulo}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <CamposItemCarrosselComponent
                                index={iMenu}
                                itemCarrossel={item}
                                setVal={(val) => handleChageItemCarrossel(val)}
                                removeItem={(id) => removerItemCarrossel(id)}
                              />
                            </AccordionDetails>
                          </Accordion>
                        )}
                      </Draggable>
                    ))
                  }
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <div className="bts">
            <Button className='bt add' onClick={addCarrossel}><AddIcon />Adicionar item</Button>
            {/* <Button className='bt remove' onClick={() => props.removeItem(props.menusFooter?.id)}><DeleteIcon /> Remover menu</Button> */}
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={1}>
          <h2>Estilo carrossel</h2>
          <label className='w50'>
            <span>Cor de fundo:</span>
            <input type='color' value={bgInput} onChange={(val) => setBgInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do título:</span>
            <input type='color' value={corDoTituloInput} onChange={(val) => setCorDoTituloInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do texto:</span>
            <input type='color' value={corDoTextoInput} onChange={(val) => setCorDoTextoInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor de fundo legenda:</span>
            <input type='color' value={corDeFundoLegendaInput} onChange={(val) => setCorDeFundoLegendaInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do texto legenda:</span>
            <input type='color' value={corDoTextoLegendaInput} onChange={(val) => setCorDoTextoLegendaInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor do bullets:</span>
            <input type='color' value={corDoBulletsInput} onChange={(val) => setCorDoBulletsInput(val.currentTarget.value)} />
          </label>
          <label className='w50'>
            <span>Cor da borda:</span>
            <input type='color' value={corDaBordaInput} onChange={(val) => setCorDaBordaInput(val.currentTarget.value)} />
          </label>
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={2}>
          <h2>Opções carrossel</h2>
          <div className="campo w100">
            <TextField value={qtdPorSlideInput} onChange={(event) => setQtdPorSlideInput(parseInt(event.target.value))} label="Quantidade por slide" />
          </div>
          <div className="campo check w50">
            <FormControl>
              <Checkbox
                checked={loopInput}
                onChange={(event) => setLoopInput(event.target.checked)}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              <FormLabel>Loop</FormLabel>
            </FormControl>
          </div>
          <div className="campo check w50">
            <FormControl>
              <Checkbox
                checked={autoPlayInput}
                onChange={(event) => setAutoPlayInput(event.target.checked)}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              <FormLabel>Autoplay</FormLabel>
            </FormControl>
          </div>
          <div className="campo check w50">
            <FormControl>
              <Checkbox
                checked={fullInput}
                onChange={(event) => setFullInput(event.target.checked)}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              <FormLabel>Full</FormLabel>
            </FormControl>
          </div>
          <div className="campo check w50">
            <FormControl>
              <Checkbox
                checked={bordaArredondadaInput}
                onChange={(event) => setBordaArredondadaInput(event.target.checked)}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              <FormLabel>Borda arredondada</FormLabel>
            </FormControl>
          </div>
        </CustomTabPanel>
      </Box>

      <div className="bts">
        <Button className='bt remove' onClick={() => props.removeItem(props.componente?.id)}><DeleteIcon /> Remover carrossel</Button>
      </div>
    </section>
  );
}

export default CamposComponenteCarrosselComponent;
